import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getDistributorById } from "../../../apis/distributors";
import { getDiscountById } from "../../../apis/discount";

const ViewDiscount = () => {
  const [formData, setFormData] = useState<any>();

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const rawData = queryParams.get("EmployeeData");
  if (rawData) {
    console.error(JSON.parse(rawData), "rawdata");
  }

  const distributorDetaile = async () => {
    try {
      const response = await getDiscountById(rawData);
      setFormData(response);
    } catch (error) {
      console.error("error");
    }
  };

  useEffect(() => {
    distributorDetaile();
  });

  return (
    <>
      {/* Page Wrapper */}

      <div className="page-wrapper">
        <div className="content">
          {formData && (
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h2>Discount Details</h2>
                <div className="container mt-5">
                  <form>
                    <div className="raw-div-1">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Full Name
                        </label>
                        <input
                          type="full_name"
                          className="form-control"
                          id="full_name"
                          name="full_name"
                          value={formData.full_name}
                          disabled
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          User Name
                        </label>
                        <input
                          type="full_name"
                          className="form-control"
                          id="user_name"
                          name="user_name"
                          value={formData.full_name}
                          disabled
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="rate" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={formData.email}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="raw-div-2">
                      <div className="mb-3">
                        <label htmlFor="rate" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="phone_number"
                          name="phone_number"
                          value={formData.phone_number}
                          disabled
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="address" className="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          name="adress"
                          value={formData.address}
                          disabled
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="geo_location" className="form-label">
                          Geo Location
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="geo_location"
                          name="geo_location"
                          value={formData.geo_location}
                          disabled
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewDiscount;
